import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { Events } from './services/events.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'หน้าหลัก',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'สั่งสินค้า',
      url: '/request-order',
      icon: 'add'
    },
    {
      title: 'บันทึกยอดขาย',
      url: '/add-income',
      icon: 'money'
    }
  ];

  public appStaffPages = [
    {
      title: 'หน้าหลัก',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'สั่งสินค้า',
      url: '/request-order',
      icon: 'add'
    },
    {
      title: 'รายการบันทึกยอดขาย',
      url: '/income-list',
      icon: 'list'
    },
    // {
    //   title: 'บันทึกยอดขาย',
    //   url: '/add-income',
    //   icon: 'wallet'
    // },
    // {
    //   title: 'บันทึกค่าใช้จ่าย',
    //   url: '/add-expense',
    //   icon: 'wallet'
    // }
  ];

  public adminPages = [
    // {
    //   title: 'หน้าหลัก',
    //   url: '/home',
    //   icon: 'home'
    // },
    // {
    //   title: 'สั่งสินค้า',
    //   url: '/request-order',
    //   icon: 'add'
    // },
    {
      title: 'อนุมัติรายการ',
      url: '/approve-request',
      icon: 'checkmark'
    },
    {
      title: 'อนุมัติยอดขาย',
      url: '/approve-income',
      icon: 'wallet'
    },
  ];

  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  userData: any;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    private router: Router,
    private events: Events,
  ) {
    this.initializeApp();

    events.subscribe('user:login', () => {
      this.storage.get('bpuser').then(user => {
        if (user) {
          this.userData = user;
          if (user.type === 'STAFF') {
            this.appPages = this.appStaffPages;
            this.router.navigate(['/home']);
          } else if (user.type === 'MANAGER') {
            this.appPages = this.adminPages;
            this.router.navigate(['/approve-request']);
          }
        }
      });
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.storage.get('bpuser').then(user => {
        if (user) {
          this.userData = user;
          if (user.type === 'STAFF') {
            this.appPages = this.appStaffPages;
            this.router.navigate(['/home']);
          } else if (user.type === 'MANAGER') {
            this.appPages = this.adminPages;
            this.router.navigate(['/approve-request']);
          }
          // this.router.navigate(['/report']);
        }
      });
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }
  }

  onClickLogout() {
    this.storage.remove('bpuser').then(logout => {
      this.router.navigate(['/login']);
    });
  }
}
